import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import { router } from './router'
import { installerAnnoncesRoute } from './router/annonces'
import { gererSessionPerdue } from './router/session-perdue'
import { i18n } from './i18n'
import { setUnauthorizedHandler } from './api/client'
import { useAuthStore } from './stores/auth'
import { initThemeEager } from './stores/theme'
import { initA11yEager } from './stores/a11y'
import { initApparenceEager, rafraichirApparence } from './apparence/appliquer'

// Polices auto-hébergées. Le socle CSS déclare « Inter » et « JetBrains Mono »
// avec repli sur la pile système : sans ces imports l'application reste lisible,
// mais perd l'allure prévue par le design system. Seuls les poids réellement utilisés sont
// importés — en ajouter alourdirait le bundle pour rien.
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/jetbrains-mono/400.css'
import './assets/main.css'

// Thème et accessibilité appliqués avant le montage : le script en ligne de
// index.html couvre la première peinture, ceux-ci couvrent la suite. Une police
// qui grossit APRÈS la première peinture fait sauter toute la mise en page sous
// les yeux de l'utilisateur.
initThemeEager()
initA11yEager()
// Couleurs de la plateforme : la dernière version connue tout de suite, celle
// du serveur en tâche de fond — même raison que la revalidation de session
// plus bas, attendre le réseau pour peindre ralentirait chaque chargement.
initApparenceEager()
void rafraichirApparence()

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(i18n)

// APRÈS pinia et i18n : le crochet résout le store d'accessibilité et traduit le
// titre à chaque navigation, donc les deux doivent être installés.
installerAnnoncesRoute(router)

// Le client HTTP ne connaît ni Pinia ni le routeur : il signale simplement
// « la session n'est plus valable » et c'est ici qu'on décide quoi en faire.
// Ce câblage doit venir APRÈS `app.use(pinia)`, sans quoi `useAuthStore()`
// n'aurait pas d'instance active à résoudre.
setUnauthorizedHandler(() => gererSessionPerdue(router, useAuthStore()))

// Revalidation en tâche de fond : l'interface s'affiche immédiatement avec la
// session locale, et un jeton révoqué entre-temps (compte désactivé, mot de
// passe changé sur un autre poste) déclenche la déconnexion dès la réponse.
// Volontairement non bloquant — attendre le réseau pour peindre le premier
// écran est ce qui donne l'impression d'une application lente.
void useAuthStore(pinia).refreshUser()

app.mount('#app')
